import { memoize } from 'proxy-memoize';
import { TagStore } from '../store/tagStore';

export const getTag = memoize((s: TagStore) => s.tags);

export const getFnSetTag = memoize((s: TagStore) => s.setTags);
